export default "__VITE_ASSET__Dgw7d$yd__"